import { render, staticRenderFns } from "./reminder-add.vue?vue&type=template&id=619300fa&scoped=true&"
import script from "./reminder-add.vue?vue&type=script&lang=js&"
export * from "./reminder-add.vue?vue&type=script&lang=js&"
import style0 from "./reminder-add.vue?vue&type=style&index=0&id=619300fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619300fa",
  null
  
)

export default component.exports